export const COMMENT_COMPOSER_LABELS = {
  send: 'Send',
  save: 'Save',
  cancel: 'Cancel',
} as const

export const overLimitMessage = (maxLength: number) =>
  `Comments are limited to ${maxLength.toLocaleString()} characters.`
